<template>
    <q-page padding>
        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab slot="title" name="webcasts" :label="$t('webinars')" icon="fal fa-broadcast-tower" />

            <q-tab-pane name="webcasts" class="q-px-md q-pb-xl q-mt-md">
                <div class="row gutter-sm" v-if="finished_loading">
                    <div class="col-xs-12 col-sm-3">
                        <filter-webcasts />
                    </div>
                    <div class="col-xs-12 col-sm-9">

                        <div class="col-12 desktop-only" v-if="banners.length > 0">
                            <q-carousel class="text-white" height="200px" infinite autoplay>
                                <q-carousel-slide :img-src="banner.image_desktop" v-for="(banner, index) in banners" :key="index" />
                            </q-carousel>
                        </div>

                        <div class="col-12 mobile-only" v-if="banners.length > 0 && showBanner">
                            <q-carousel class="text-white" :height="`${getHeight}px`" infinite autoplay>
                                <q-carousel-slide :img-src="banner.image_mobile" v-for="(banner, index) in banners" :key="index" />
                            </q-carousel>
                        </div>

                        <div class="row gutter-md q-mt-xs">
                            <div class="col-xs-12 col-sm-12" v-for="(webcast, index) in filteredWebcasts" :key="index">
                                <card-desktop :webcast="webcast" v-if="$q.platform.is.desktop" :key="webcast.id" @subscribe_webcast="subscribeWebcast(webcast)" />

                                <card-mobile :webcast="webcast" v-if="$q.platform.is.mobile" :key="webcast.id" @subscribe_webcast="subscribeWebcast(webcast)" />
                            </div>

                            <div class="col-xs-12 col-sm-12" v-if="filteredWebcasts.length == 0">
                                <q-card>
                                    <q-card-title>
                                        {{ $t('no_webcasts_found') }}
                                    </q-card-title>
                                    <q-card-separator />
                                    <q-card-main v-if="this.search || this.selected_areas.length > 0 || this.progress != 'all'">
                                        {{ $t('searched_term_returned_no_results') }}
                                    </q-card-main>
                                    <q-card-main v-else>
                                        {{ $t('there_are_no_webcasts_avaliable_at_the_moment') }}
                                    </q-card-main>
                                </q-card>
                            </div>
                        </div>
                    </div>
                </div>

                <q-inner-loading :visible="!finished_loading">
                    <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
                </q-inner-loading>
            </q-tab-pane>
        </q-tabs>

        <q-dialog prevent-close v-model="confirm_subscribe_webcast" class="dialog-webcast">
            <span slot="title">{{ $t(getWebcastSubscribeTitle()) }}</span>

            <span slot="message">
                {{ `${$t(getWebcastSubscribeText())} ${webcast.title}` }}
            </span>

            <span slot="body" v-if="!webcast.webcast_user_subscribed">
                <q-field>
                    <q-checkbox v-model="check_emails_webcast" :label="$t('receive_emails_about_this_webcast')" />
                </q-field>
            </span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="tertiary" :label="$t('cancel')" @click="cancelSubscribeWebcast()" />
                <q-btn :color="getWebcastSubscribeButtonColor()" :label="$t(getWebcastSubscribeButton())" @click="saveSubscribeWebcast()" />
            </template>
        </q-dialog>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Filter from 'components/webcasts/Filter'
import CardDesktop from 'components/webcasts/CardDesktop'
import CardMobile from 'components/webcasts/CardMobile'
import Webcast from 'components/webcasts/Webcast'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "webcast"] },

    data() {
        return {
            tab: 'webcasts',
            loaded_lists: false,
            webcasts: [],
            webcast: [],
            finished_loading: false,
            confirm_subscribe_webcast: false,
            check_emails_webcast: true,
            banners: []
        }
    },

    components: {
        'filter-webcasts': Filter,
        'card-desktop': CardDesktop,
        'card-mobile': CardMobile
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            reload_content: 'common/reload_content',
            search: 'webcasts/search',
            progress: 'webcasts/progress',
            groups: 'webcasts/groups',
            areas: 'registration_lists/country_areas',
            selected_tags: 'webcasts/tags',
            selected_areas: 'webcasts/areas',
            clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        filteredWebcasts() {
            let filtered = []
            filtered = Object.assign(this.webcasts, [])

            if (this.search) {
                filtered = filtered.filter((webcast) => {
                    return webcast.title.toUpperCase().includes(this.search.toUpperCase())
                })
            }

            if (this.selected_areas.length > 0) {
                filtered = filtered.filter((webcast) => {
                    let result = this.selected_areas.filter(x => webcast.areas.includes(x))
                    return result.length > 0 ? true : false
                })
            }

            if (this.progress != 'all') {
                filtered = filtered.filter((webcast) => {
                    if (this.progress == 'to-do') {
                        return webcast.status == 1 ? true : false
                    }
                    else if (this.progress == 'finished') {
                        return webcast.status == 4 ? true : false
                    }
                })
            }

            return filtered
        },

        showBanner() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) {
                if(obj.show_banner_mobile) return true
                else return false
            }
            else return true
        },

        getHeight() {
            let height = (180 / 323) * this.$q.screen.width
            return parseInt(height)
        },
    },

    methods: {
        fetchAll() {
            this.$q.loading.show()

            this.$axios.all([this.fetchLists(), this.fetchBanners()])
            .then(this.$axios.spread((lists, banners) => {
                this.$store.dispatch('site_lists/SET_LISTS', [lists.data])

                banners.data.map((banner) => {
                    this.banners.push(banner)
                })

                this.$q.loading.hide()
            }))
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        fetchLists() {
            return this.$axios.get('/accounts/get_site_registration_lists/', this.getHeader)
        },

        fetchBanners() {
            return this.$axios.get('/etraining_banners/banners/get_banner_by_type/?banner_type=3', this.getHeader)
        },

        fetchWebcasts() {
            this.$q.loading.show()

            this.webcasts = []

            this.$axios.get('/etraining_webcasts/webcasts/', this.getHeader)
            .then(response => {
                response.data.results.forEach(webcast => {
                    let image_small = ''
                    let image_thumb = ''

                    let obj = webcast.webcast_images.find((obj) => { return obj.name === 'thumbnail' })
                    if (obj) image_thumb = obj.image

                    obj = webcast.webcast_images.find((obj) => { return obj.name === 'small' })
                    if (obj) image_small = obj.image

                    this.webcasts.push({
                        id: webcast.id,
                        image_thumb: image_thumb,
                        image_small: image_small,
                        areas: webcast.areas,
                        user_groups: webcast.user_groups,
                        tags: webcast.tags,
                        title: webcast.title,
                        description: webcast.description,
                        embed: webcast.embed,
                        score: webcast.score,
                        qty_webcast_evaluations: webcast.qty_webcast_evaluations,
                        transmission_date: webcast.transmission_date,
                        timezone: this.getHumanTimezone(webcast.timezone),
                        use_chat: webcast.use_chat,
                        chat_moderated: webcast.chat_moderated,
                        status: webcast.status,
                        user_progress: parseInt(webcast.user_progress),
                        user_progress_string: webcast.user_progress_string ? webcast.user_progress_string : "0",
                        webcast_user_result_status: webcast.webcast_user_result_status,
                        webcast_user_result_date: date.formatDate(webcast.webcast_user_user_result_date, 'DD/MM/YYYY'),
                        webcast_user_subscribed: webcast.webcast_user_subscribed,
                        webcast_wowza_id: webcast.webcast_wowza_id,
                        webcast_player_hls_playback_url: webcast.webcast_player_hls_playback_url,
                    })
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.finished_loading = true
                this.$q.loading.hide()
            })
        },

        hideModal() {
            this.webcast = []
            this.show_modal = false
        },

        subscribeWebcast(webcast) {
            this.webcast = webcast
            this.confirm_subscribe_webcast = true
        },

        saveSubscribeWebcast() {
            this.$q.loading.show()

            let fd = new FormData
            fd.append('receive_notifications', this.check_emails_webcast)

            this.$axios.post(`/etraining_webcasts/webcasts/${this.webcast.id}/save_subscription/`, fd, this.getHeader)
            .then(response => {
                if (response.data.orientation === 'subscribed') {
                    this.webcast.webcast_user_subscribed = true

                    this.$q.notify({
                        message: this.$t('subscribed_for_webcast_successfuly'),
                        type: 'positive',
                        icon: 'fal fa-sign-in'
                    })
                }
                else {
                    this.webcast.webcast_user_subscribed = false

                    this.$q.notify({
                        message: this.$t('unsubscribed_for_webcast_successfuly'),
                        type: 'positive',
                        icon: 'fal fa-sign-out'
                    })
                }
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
                this.confirm_subscribe_webcast = false
            })
        },

        cancelSubscribeWebcast() {
            this.confirm_subscribe_webcast = false
            this.check_emails_webcast = true
            this.hideModal()
        },

        getWebcastSubscribeTitle() {
            if (!this.webcast.webcast_user_subscribed) return 'subscribe'
            else return 'unsubscribe'
        },

        getWebcastSubscribeButton() {
            if (!this.webcast.webcast_user_subscribed) return 'subscribe'
            else return 'unsubscribe'
        },

        getWebcastSubscribeButtonColor() {
            if (!this.webcast.webcast_user_subscribed) return 'positive'
            else return 'negative'
        },

        getWebcastSubscribeText() {
            if (!this.webcast.webcast_user_subscribed) return 'confirm_subscribing_to_the_webcast'
            else return 'confirm_unsubscribing_to_the_webcast'
        },

        getHumanTimezone(location) {
            const gmt = moment.tz(location).format('z')
            if (gmt === 'GMT') {
                return `${gmt} 0`
            } else return `GMT ${gmt}`
        }
    },

    watch: {
        search: function() {
            this.fetchWebcasts()
        },

        tags: function() {
            this.fetchWebcasts()
        },

        progress: function() {
            this.fetchWebcasts()
        },

        reload_content: function() {
            this.fetchWebcasts()
        }
    },

    created() {
        this.fetchAll()
        this.fetchWebcasts()
    }
}
</script>

<style lang="stylus" scoped>
p
    margin 0 0 10px

.training-thumb
    width 90%
    height auto
    border-radius 10px
</style>
